import { render, staticRenderFns } from "./RushRacePlayerLink.vue?vue&type=template&id=2d04547d&"
import script from "./RushRacePlayerLink.vue?vue&type=script&lang=js&"
export * from "./RushRacePlayerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports